import { render, staticRenderFns } from "./BuildingTab.vue?vue&type=template&id=570de265"
import script from "./BuildingTab.vue?vue&type=script&lang=js"
export * from "./BuildingTab.vue?vue&type=script&lang=js"
import style0 from "./BuildingTab.vue?vue&type=style&index=0&id=570de265&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports